import React from 'react';
import { StyledBanner } from './StyledComponents';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@app/AppRoutes/routes';
import { BannerProps } from '../types';

export default function PaymentFailureBanner({ setIsVisible }: BannerProps) {
	const navigate = useNavigate();
	const { t } = useTranslation('common');

	return (
		<StyledBanner
			className="cursor-default"
			id="payment-failure-banner"
			variant="error"
			intense
			onDismiss={() => setIsVisible(false)}
			message={t('payment_failure_banner_title')}
			description={t('payment_failure_banner_description')}
			iconProps={{
				iconName: 'triangleExclamation',
				size: 'lg',
			}}
			action={{
				label: t('update_payment'),
				onClick: () => {
					setIsVisible(false);
					return navigate(ROUTES.UPGRADE_PLAN.UPDATE_PAYMENT_METHOD.path, {
						state: {
							from: window.location.pathname,
						},
					});
				},
			}}
		/>
	);
}
